import { jsx as _jsx } from "preact/jsx-runtime";
import { Suspense, lazy } from 'preact/compat';
import register from 'preact-custom-element';
import { captureException } from '@/lib/sentry';
// The blank svg takes up the same space as an icon would whilst the icon is loading
import BlankSvg from './svg/blank.svg?react';
export default function Icon({ icon, label }) {
    if (!icon || icon === 'undefined') {
        return null;
    }
    const IconSvg = lazy(() => {
        return import(`./svg/${icon}.svg?react`).catch((error) => {
            captureException(error, {
                component: 'IconSvg',
                iconName: icon,
            });
            return Promise.resolve({ default: BlankSvg });
        });
    });
    return (_jsx(Suspense, { fallback: BlankSvg, children: _jsx(IconSvg, { "aria-label": label, "aria-hidden": !label }) }));
}
register(Icon, 'locator-icon', ['icon', 'label']);
